$(".new-iwt-more").click(function(){
  $(this).prev(".new-iwt-text").slideToggle(300);
  $(this).toggleClass("active");
})
$(".footer-block__heading").click(function(){
  if($(this).hasClass("active")){
      $(this).toggleClass("active");
      $(this).next(".footer-block__details-content").slideToggle(250);
  }
  else{
      $(this).parents(".footer__blocks-wrapper").find(".footer-block__heading").removeClass("active");
      $(this).parents(".footer__blocks-wrapper").find(".footer-block__details-content").slideUp(250);
      $(this).addClass("active");
      $(this).next(".footer-block__details-content").slideDown(250);
  }
});

$(".custom-main-product-swatch").hover(function(){
  $(".custom-product-swatch-heading span").text($(this).attr("data-title"));
}, function(){
  $(".custom-product-swatch-heading span").text($(this).attr("data-d-title"));
})
$(".new-popup-title, .new-popup-close, .new-popup-overlay").click(function(){
  $(".new-popup-overlay, .new-popup-wrapper").fadeToggle(300);
})